<style src="./styles.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <form>
      <div class="from-group">
        <label>Assunto</label>
        <input type="text" class="form-control" v-model="form.subject" />
      </div>
      <br />
      <div class="from-group">
        <label>Descrição</label>
        <textarea
          type="text"
          class="form-control"
          rows="5"
          cols="33"
          v-model="form.description"
        />
      </div>
      <br />
      <div class="row">
        <div class="from-group col-md-3">
          <label>Veículo - Placa</label>
          <input type="text" class="form-control" v-model="form.licencePlate" />
        </div>
        <template v-if="isEdition">
          <div class="from-group col-md-3">
            <label>Monitor</label>
            <input
              type="text"
              disabled
              class="form-control"
              v-model="form.employee"
            />
          </div>
          <div class="from-group col-md-2">
            <label>Lido</label>
            <div class="icon-container">
              <i v-if="form.isRead === true" class="fa fa-check"></i>
              <i v-else class="fa fa-times"></i>
            </div>
          </div>
          <div class="from-group col-md-2">
            <label>Pendente</label>
            <switches
              v-model="form.isPending"
              class="checkbox-content"
              theme="bootstrap"
              color="success"
              :emit-on-mount="false"
            ></switches>
          </div>
          <div class="from-group col-md-2">
            <label>Fechado</label>
            <switches
              v-model="form.isClosed"
              class="checkbox-content"
              theme="bootstrap"
              color="success"
              :emit-on-mount="false"
            ></switches>
          </div>
        </template>
      </div>

      <br />
      <button
        type="button"
        class="btn btn-block btn-primary compose-mail"
        href="mail_compose.html"
        v-if="isEdition"
        @click="updateMovement"
      >
        <i class="fa fa-save"></i>
        Salvar
      </button>
      <button
        v-else
        type="button"
        class="btn btn-block btn-primary compose-mail"
        href="mail_compose.html"
        @click="registerMovement"
      >
        <i class="fa fa-save"></i>
        Registrar
      </button>
    </form>
  </div>
</template>

<script>
import Switches from 'vue-switches';
export default {
  components: {
    Switches,
  },
  data() {
    return {
      form: {
        description: '',
        subject: '',
        employee: '',
        licencePlate: '',
        isRead: false,
        isPending: false,
        isClosed: false,
      },
    };
  },
  computed: {
    isEdition() {
      return this.$route.params.requestId;
    },
  },
  mounted() {
    this.getRequestGuard();
  },
  methods: {
    async registerMovement() {
      try {
        const payload = {
          description: this.form.description,
          subject: this.form.subject,
          licencePlate: this.form.licencePlate,
        };
        await this.$store.dispatch('GUARD-REQUEST/Create', payload);
        this.$toasted.success('Mensagem enviada');
        this.$router.go(-1);
      } catch (error) {
        this.$toasted.error('Não foi possível criar a requisição');
      }
    },
    async updateMovement() {
      try {
        const payload = {
          description: this.form.description,
          subject: this.form.subject,
          licencePlate: this.form.licencePlate,
          isPending: this.form.isPending,
          isClosed: this.form.isClosed,
        };

        await this.$store.dispatch('GUARD-REQUEST/Update', {
          payload,
          guardRequestId: this.isEdition,
        });
        this.$toasted.success('Requisição Editada');
        this.$router.go(-1);
      } catch (error) {
        this.$toasted.error('Não foi possível criar a requisição');
      }
    },
    async getRequestGuard() {
      try {
        if (!this.isEdition) {
          return null;
        }
        const guardRequest = await this.$store.dispatch(
          'GUARD-REQUEST/ListOne',
          this.isEdition,
        );

        this.form.description = guardRequest.description;
        this.form.employee = guardRequest.employee.fullName;
        this.form.licencePlate = guardRequest.vehicle
          ? guardRequest.vehicle.licencePlate
          : '';
        this.form.subject = guardRequest.subject;
        this.form.isRead = guardRequest.isRead;
        this.form.isPending = guardRequest.isPending;
        this.form.isClosed = guardRequest.isClosed;
      } catch (error) {
        this.$toasted.error('Não foi possível listar a requisição');
      }
    },
  },
};
</script>